'use client'

import { HeartFilled16 } from '@vinted/monochrome-icons'
import { ColorCode, Icon, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/domain/audit'
import {
  landingPageEvent,
  InfluencerProductCardModel,
  InfluencerLandingPageEvent,
} from '@marketplace-web/domain/marketing-landing-page-data'

import { ClickableElement } from '../../../../../../../../app/constants/tracking/clickable-elements'

const NewProductCard = ({
  title,
  thumbnailUrl,
  productUrl,
  testId,
}: InfluencerProductCardModel) => {
  const { track } = useTracking()

  const handleCardClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.ProductCardClick,
        target: ClickableElement.ProductCardInfluencerLandingPage,
        targetDetails: productUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <article className="influencer-v2__product-card">
      <a href={productUrl} onClick={handleCardClick}>
        <div className="influencer-v2__product-card-image">
          {thumbnailUrl && (
            <Image
              src={thumbnailUrl}
              loading="lazy"
              scaling={Image.Scaling.Cover}
              testId={testId}
            />
          )}
          <div className="influencer-v2__fave-icon">
            <Icon name={HeartFilled16} color={ColorCode.WarningMedium} />
          </div>
        </div>
        <h3 className="influencer-v2__product-card-title">{title}</h3>
      </a>
    </article>
  )
}

export default NewProductCard
